import { formatDate } from "../../services/service-date";

export default class Ical {
    constructor(element) {
      this.el = element
      this.startDate = this.el.dataset.start;
      this.endDate = this.el.dataset.end;
      this.summary = this.el.dataset.summary;
      this.description = this.el.dataset.description;
      this.street = this.el.dataset.street;
      this.zipcode = this.el.dataset.zipcode;
      this.city = this.el.dataset.city;
      this.generateIcsFile = this.generateIcsFile.bind(this);
      this.convertDateFormat = this.convertDateFormat.bind(this);
      
      this.init()
    }
  
    init() {
        this.el.addEventListener('click', e =>{
           this.generateIcsFile(); 
        })
      }

    convertDateFormat(dateTime) {
        let fullDate = dateTime.split(" ").join("T");
        let year = fullDate.substring(6, 10);
        let month = fullDate.substring(3, 5);
        let day = fullDate.substring(0, 2);
        let time = fullDate.substring(10, 19)
        time = time.split(".").join("");
        let formattedDate = encodeURIComponent(year + month + day + time + "00");
        return formattedDate;
    }

    generateIcsFile() {
        let icsFile =
        "BEGIN:VCALENDAR\n" +
        "CALSCALE:GREGORIAN\n" +
        "METHOD:PUBLISH\n" +
        "PRODID:-//Test Cal//EN\n" +
        "VERSION:2.0\n" +
        "BEGIN:VEVENT\n" +
        "UID:test-1\n" +
        "LOCATION:" + this.street + ", " + this.zipcode + this.city +
        "\n" +
        "DTSTART;VALUE=DATE:" +
        this.convertDateFormat(this.startDate) +
        "\n" +
        "DTEND;VALUE=DATE:" +
        this.convertDateFormat(this.endDate) +
        "\n" +
        "SUMMARY:" +
        this.summary +
        "\n" +
        "DESCRIPTION:" +
        this.description +
        "\n" +
        "END:VEVENT\n" +
        "END:VCALENDAR";
        
        this.downloadIcsFile("calendarevent" + '.ics', icsFile);
    }

    downloadIcsFile(filename, fileBody) {
        let element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(fileBody));
        element.setAttribute('download', filename);
        element.setAttribute('target', "_blank");
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();  
    } 
  }
